"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCamelCase = exports.padStart = exports.validateString = exports.titleCase = exports.camelToSnakeCase = exports.toPascalCase = void 0;

var __1 = require("..");

var __2 = require(".."); // export const emDash = "\u2014";


var toPascalCase = function toPascalCase(word) {
  return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "";
};

exports.toPascalCase = toPascalCase; // works with camelCase Strings or Multi Word Strings

var camelToSnakeCase = function camelToSnakeCase(str) {
  str = str.trim();
  var stringHasSpaces = str.match(/\s+/g);
  var stringHasUpper = str.toLowerCase() !== str;

  if (stringHasSpaces) {
    return str.replace(/\s+/gm, "-").replace(/[a-zA-Z0-9]/g, function (letter, index) {
      return "".concat(letter.toLowerCase());
    });
  } else if (stringHasUpper) {
    return str.replace(/[a-zA-Z0-9]/g, function (letter, index) {
      return "".concat(letter.toUpperCase() === letter ? "-" + letter.toLowerCase() : letter.toLowerCase());
    });
  } else {
    return "".concat(str.toLowerCase());
  }
};

exports.camelToSnakeCase = camelToSnakeCase;

var titleCase = function titleCase() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

exports.titleCase = titleCase;

var validateString = function validateString(value, isRequired) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __1.Language.en;
  var error = "";

  if (!value && isRequired) {
    error = __2.CONSTANTS[language].REQUIRED_FIELD;
  } else if (value && !value.match(/^[a-zA-Z]+$/)) {
    error = __2.CONSTANTS[language].ALPHABET_ERROR;
  }

  return error;
};

exports.validateString = validateString;

var padStart = function padStart(originalString, targetLength, padString) {
  targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;

  padString = String(typeof padString !== "undefined" ? padString : " ");

  if (originalString.length > targetLength) {
    return originalString;
  } else {
    targetLength = targetLength - originalString.length;

    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
    }

    return padString.slice(0, targetLength) + originalString;
  }
};

exports.padStart = padStart;

var toCamelCase = function toCamelCase(word) {
  var regExp = /(?:^\w|[A-Z]|\b\w)/g;
  return word ? word.replace(regExp, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/[^a-zA-Z0-9]/g, "") : "";
};

exports.toCamelCase = toCamelCase;
var StringUtilities = {
  toPascalCase: exports.toPascalCase,
  camelToSnakeCase: exports.camelToSnakeCase,
  titleCase: exports.titleCase,
  validateString: exports.validateString,
  padStart: exports.padStart,
  toCamelCase: exports.toCamelCase
};
exports.default = StringUtilities;